import React from 'react'

const Exceptions = () => {
    return (
        <>Exceptions mobile</>
    )
}

export { Exceptions }